<app-template>
    <!-- FAD MASIVO DESKTOP -->
    <div class="fad-desktop" *ngIf=" isMobile === false && isTablet === false ">
        <div class="container-privacy">
            <div class="header-privacy">
                <h1><p>
                    CONFORMIDADE <br> LEGAL
                </p></h1>
            </div>
            <div class="privacy-content">
                <p>
                    A assinatura eletrônica é a forma de comprovação da manifestação de vontade por meio ou
                    com a utilização de tecnologias que garantam o teste de integridade e cujo objetivo principal é
                    identificar quem produziu a declaração de uma ou mais partes.
                    <br><br>A emissão da assinatura digital está regulamentada na legislação brasileira, desde 2001,
                    inicialmente com a Medida Provisória 2.200, de 28 de junho de 2001, e posteriormente as MP 2200-1 e
                    2.200-2 do artigo 10 da MP 2.200-2, estabelece que a referida norma não impede a utilização de
                    outros meios que comprovem a integridade de documentos em formato eletrônico, além do PCI - Brasil,
                    conforme segue: “O disposto nesta Medida Provisória não impede a utilização de outros meios de
                    comprovação de autoria e integridade de documentos em formato eletrônico, inclusive os que utilizam
                    certificados não emitidos pela ICP-Brasil, desde que aceito pelas partes como válido ou aceito pela
                    pessoa a quem o documento. "
                    <br><br>Isso significa que o uso de assinaturas diferentes das assinaturas credenciadas pela ICP-BRASIL, é
                    totalmente válido e legal. Não é necessário ter o “credenciamento de terceiro”, mas sua validade em
                    determinado uso é validada por acordo das partes. Nesse sentido, devem garantir poder assegurar a
                    atribuição da assinatura, ou seja, poder determinar quem é o signatário e também zelar pela sua
                    integridade, para que os interessados e terceiros possam ter a certeza de que o documento tem
                    permaneceu inalterado ao longo do tempo. É assim que podemos garantir que o "FAD" cumpre
                    integralmente cada uma destas normas, uma vez que a gravação em vídeo e a declaração expressa do
                    titular da assinatura "aceitando os termos do contrato" geram prova irrefutável aos olhos do juiz,
                    quem também Você pode usar outros mecanismos para reforçar essa atribuição, como biometria gráfica,
                    geolocalização do dispositivo, IP, etc.
                    <br><br>Quanto à integridade, o FAD imprime um HASH ou uma impressão digital, que é carimbada por um
                    Timestamp ou certificado de conservação de um terceiro que possa ser credenciado e autorizado pelo
                    ICP-BRASIL para a emissão desses carimbos, e estando lacrado, é garantido que o documento
                    permanecerá inalterável com o tempo. Com tudo isso, podemos concluir que o FAD é um método de
                    assinatura que não só atende às normas do BRASIL para garantir a eficácia jurídica de seus
                    documentos, mas também gera muita certeza se você deseja que seu negócio seja bem atendido.</p>
                <br>
                <br>
                <div id="form-legal"></div>
            </div>
            <br>
        </div>
    </div>

    <!-- FAD MASIVO RESPONSIVO -->
    <div class="fad-movil" *ngIf=" isMobile === true || isTablet === true ">
        <div class="box-container">
            <div class="box-img">
                <img class="img-prin" src="assets/images/m/telefonos.png">
            </div>

            <div class="content-res">
                <h1>Conformidade legal</h1>
                <p class="text">
                    A assinatura eletrônica é a forma de comprovação da manifestação de vontade por meio ou
                    com a utilização de tecnologias que garantam o teste de integridade e cujo objetivo principal é
                    identificar quem produziu a declaração de uma ou mais partes.
                    <br><br>A emissão da assinatura digital está regulamentada na legislação brasileira, desde 2001,
                    inicialmente com a Medida Provisória 2.200, de 28 de junho de 2001, e posteriormente as MP 2200-1 e
                    2.200-2 do artigo 10 da MP 2.200-2, estabelece que a referida norma não impede a utilização de
                    outros meios que comprovem a integridade de documentos em formato eletrônico, além do PCI - Brasil,
                    conforme segue: “O disposto nesta Medida Provisória não impede a utilização de outros meios de
                    comprovação de autoria e integridade de documentos em formato eletrônico, inclusive os que utilizam
                    certificados não emitidos pela ICP-Brasil, desde que aceito pelas partes como válido ou aceito pela
                    pessoa a quem o documento. "
                    <br><br>Isso significa que o uso de assinaturas diferentes das assinaturas credenciadas pela ICP-BRASIL, é
                    totalmente válido e legal. Não é necessário ter o “credenciamento de terceiro”, mas sua validade em
                    determinado uso é validada por acordo das partes. Nesse sentido, devem garantir poder assegurar a
                    atribuição da assinatura, ou seja, poder determinar quem é o signatário e também zelar pela sua
                    integridade, para que os interessados e terceiros possam ter a certeza de que o documento tem
                    permaneceu inalterado ao longo do tempo. É assim que podemos garantir que o "FAD" cumpre
                    integralmente cada uma destas normas, uma vez que a gravação em vídeo e a declaração expressa do
                    titular da assinatura "aceitando os termos do contrato" geram prova irrefutável aos olhos do juiz,
                    quem também Você pode usar outros mecanismos para reforçar essa atribuição, como biometria gráfica,
                    geolocalização do dispositivo, IP, etc.
                    <br><br>Quanto à integridade, o FAD imprime um HASH ou uma impressão digital, que é carimbada por um
                    Timestamp ou certificado de conservação de um terceiro que possa ser credenciado e autorizado pelo
                    ICP-BRASIL para a emissão desses carimbos, e estando lacrado, é garantido que o documento
                    permanecerá inalterável com o tempo. Com tudo isso, podemos concluir que o FAD é um método de
                    assinatura que não só atende às normas do BRASIL para garantir a eficácia jurídica de seus
                    documentos, mas também gera muita certeza se você deseja que seu negócio seja bem atendido.</p>
                <br>
                <div id="form-legal"></div>
            </div>
        </div>
    </div>
</app-template>
